module.exports = "pegasus_template/assets/repeat-large.png";